import { t } from "i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type ErrorMessageModalProps = {
  error?: Error;
  resetErrorBoundary?: () => void;
};

export function ErrorMessageModal({
  error,
  resetErrorBoundary,
}: Readonly<ErrorMessageModalProps>) {
  const handleReload = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    } else {
      window.location.reload();
    }
  };

  return (
    <Modal isOpen backdrop="static" keyboard={false} centered>
      <ModalHeader>{t("errorModal.title")}</ModalHeader>

      <ModalBody>
        <p className="mb-2">{t("errorModal.message")}</p>

        <p className="text-muted mb-3">{t("errorModal.recoverMessage")}</p>

        {error && (
          <pre className="text-danger small mb-0 fg-error-modal-content">
            {error?.message}
            {process.env.NODE_ENV !== "production" && error?.stack
              ? `\n\n${error?.stack}`
              : null}
          </pre>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          className="btn fg-btn fg-btn-filled-darkblue"
          color="primary"
          onClick={handleReload}
        >
          {t("errorModal.reloadButton")}
        </button>
      </ModalFooter>
    </Modal>
  );
}
